export const GetPagination = ({ pagination }) => pagination;
export const GetUser = ({ user }) => user;
